const settings = {
    appName: process.env.VUE_APP_NAME,
    appType: process.env.VUE_APP_ENV,
    endPointCeisa: process.env.VUE_APP_ENPOINT_CEISA,
  }

export default settings;